import React from "react";
import Login from "../components/Auth/Login";

export default function Register() {
  return <Login />;
}
